// action types
import { createRequestTypes } from "../../utils";

// Note CRUD
export const CREATE_NOTE = createRequestTypes("CREATE_NOTE");
export const UPDATE_NOTE = createRequestTypes("UPDATE_NOTE");
export const DELETE_NOTE = createRequestTypes("DELETE_NOTE");

// Note queries
export const GET_NOTES_BY_ORGANIZATION = createRequestTypes("GET_NOTES_BY_ORGANIZATION");
export const GET_NOTES_BY_BATCH = createRequestTypes("GET_NOTES_BY_BATCH");
export const GET_NOTES_BY_STAGE = createRequestTypes("GET_NOTES_BY_STAGE");
export const GET_NOTES_BY_DATE = createRequestTypes("GET_NOTES_BY_DATE");
export const GET_NOTES_BY_TAGS = createRequestTypes("GET_NOTES_BY_TAGS");

// UI state
export const SET_SELECTED_NOTE = 'SET_SELECTED_NOTE';
export const RESET_NOTES_STATE = 'RESET_NOTES_STATE';
export const CLEAR_NOTES = 'CLEAR_NOTES';

// ----------------------------------------------------------------------
// Action Creators - Note CRUD
// ----------------------------------------------------------------------

export const createNoteRequest = (data) => ({
  type: CREATE_NOTE.REQUEST,
  payload: data,
});

export const createNoteSuccess = (data) => ({
  type: CREATE_NOTE.SUCCESS,
  payload: { data },
});

export const createNoteFailure = (error) => ({
  type: CREATE_NOTE.FAILURE,
  payload: error,
});

export const updateNoteRequest = (noteId, data) => ({
  type: UPDATE_NOTE.REQUEST,
  payload: { noteId, data },
});

export const updateNoteSuccess = (data) => ({
  type: UPDATE_NOTE.SUCCESS,
  payload: { data },
});

export const updateNoteFailure = (error) => ({
  type: UPDATE_NOTE.FAILURE,
  payload: error,
});

export const deleteNoteRequest = (noteId) => ({
  type: DELETE_NOTE.REQUEST,
  payload: noteId,
});

export const deleteNoteSuccess = (noteId) => ({
  type: DELETE_NOTE.SUCCESS,
  payload: { noteId },
});

export const deleteNoteFailure = (error) => ({
  type: DELETE_NOTE.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// Action Creators - Note Queries
// ----------------------------------------------------------------------

export const getNotesByOrganizationRequest = (organizationId, batchId = null, params = {}) => ({
  type: GET_NOTES_BY_ORGANIZATION.REQUEST,
  payload: { organizationId, batchId, params },
});

export const getNotesByOrganizationSuccess = (data) => ({
  type: GET_NOTES_BY_ORGANIZATION.SUCCESS,
  payload: { data },
});

export const getNotesByOrganizationFailure = (error) => ({
  type: GET_NOTES_BY_ORGANIZATION.FAILURE,
  payload: error,
});

export const getNotesByBatchRequest = (batchId) => ({
  type: GET_NOTES_BY_BATCH.REQUEST,
  payload: batchId,
});

export const getNotesByBatchSuccess = (data) => ({
  type: GET_NOTES_BY_BATCH.SUCCESS,
  payload: { data },
});

export const getNotesByBatchFailure = (error) => ({
  type: GET_NOTES_BY_BATCH.FAILURE,
  payload: error,
});

export const getNotesByStageRequest = (stageId) => ({
  type: GET_NOTES_BY_STAGE.REQUEST,
  payload: stageId,
});

export const getNotesByStageSuccess = (data) => ({
  type: GET_NOTES_BY_STAGE.SUCCESS,
  payload: { data },
});

export const getNotesByStageFailure = (error) => ({
  type: GET_NOTES_BY_STAGE.FAILURE,
  payload: error,
});

export const getNotesByDateRequest = (organizationId, batchId, startDate, endDate) => ({
  type: GET_NOTES_BY_DATE.REQUEST,
  payload: { organizationId, batchId, startDate, endDate },
});

export const getNotesByDateSuccess = (data) => ({
  type: GET_NOTES_BY_DATE.SUCCESS,
  payload: { data },
});

export const getNotesByDateFailure = (error) => ({
  type: GET_NOTES_BY_DATE.FAILURE,
  payload: error,
});

export const getNotesByTagsRequest = (organizationId, batchId, tags) => ({
  type: GET_NOTES_BY_TAGS.REQUEST,
  payload: { organizationId, batchId, tags },
});

export const getNotesByTagsSuccess = (data) => ({
  type: GET_NOTES_BY_TAGS.SUCCESS,
  payload: { data },
});

export const getNotesByTagsFailure = (error) => ({
  type: GET_NOTES_BY_TAGS.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// UI State Actions
// ----------------------------------------------------------------------

export const setSelectedNote = (note) => ({
  type: SET_SELECTED_NOTE,
  payload: note,
});

export const resetNotesState = () => ({
  type: RESET_NOTES_STATE,
});

export const clearNotes = () => ({
  type: CLEAR_NOTES,
});
